import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enLocale from './en';

const resources = {
  en: enLocale,
};

const initParams = {
  resources,
  lng: 'en',
  fallbackLng: false,
  interpolation: {
    escapeValue: false,
  },
};

i18n.use(initReactI18next).init(initParams);

export default i18n;
